module.exports = __webpack_public_path__ + "media/megamenu/Rush-c54cd216.svg";